module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "race-question"
  }, [_c('modal', {
    attrs: {
      "name": "question"
    },
    on: {
      "before-close": _vm.onClose
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.finishDate) + "      " + _vm._s(_vm.race.duration) + "      " + _vm._s(_vm.race.name))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.race.distance))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newdistance),
      expression: "newdistance"
    }],
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "number",
      "id": "newdistance",
      "maxlength": "255",
      "name": "newdistance",
      "Placeholder": ""
    },
    domProps: {
      "value": (_vm.newdistance)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newdistance = $event.target.value
      }
    }
  }), _vm._v(" Km\n      "), _c('div', [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn--primary",
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "id": "save-distance"
    },
    on: {
      "click": function($event) {
        return _vm.Save(_vm.newdistance)
      }
    }
  }, [_vm._v("Save")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37164ea8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LiveRun/Race/EditDistance.vue
// module id = 1653
// module chunks = 2